module.exports = __webpack_public_path__ + "static/Affiches-BRIDGE-72ppp-1-380-6d25ad716eea4e3a788f0e6d77195a6c.png";